// export type UserSelTab = 'recent' | 'agentFor' | 'org' | 'top' | 'externalContacts' | 'group' | 'custom';
export var UserSelTab;
(function (UserSelTab) {
    UserSelTab["recommend"] = "recommend";
    /** 常用联系人 */
    UserSelTab["recent"] = "recent";
    UserSelTab["agentFor"] = "agentFor";
    /** 组织架构 */
    UserSelTab["org"] = "org";
    /** 工作条线 */
    UserSelTab["workLine"] = "workLine";
    UserSelTab["top"] = "top";
    /** 我的联系人 */
    UserSelTab["externalContacts"] = "externalContacts";
    /** 我的组(只能选择组成员) */
    UserSelTab["group"] = "group";
    // groupAndMembers = 'groupAndMembers', // 我的组(既可以选择组也可以选择组)
    /** 我的组(只能选择组) */
    UserSelTab["groupCanBeSel"] = "groupCanBeSel";
    UserSelTab["custom"] = "custom";
    /** 组成员 */
    UserSelTab["business"] = "business";
    /** 最近会话 */
    UserSelTab["recentIncludeGroup"] = "recentIncludeGroup";
    /** 标签 */
    UserSelTab["tag"] = "tag";
})(UserSelTab || (UserSelTab = {}));
export var OrgType;
(function (OrgType) {
    OrgType["virtual"] = "virtual";
    OrgType["substantive"] = "substantive";
})(OrgType || (OrgType = {}));
export var SelectorMode;
(function (SelectorMode) {
    SelectorMode["forward"] = "forward";
    SelectorMode["user"] = "user";
    SelectorMode["transfer"] = "transfer";
    SelectorMode["group"] = "group";
    SelectorMode["stranger"] = "stranger";
})(SelectorMode || (SelectorMode = {}));
// export type ContactsFilterFlag = 'all' | 'external' | 'crossPlatform';
export var ContactsFilterFlag;
(function (ContactsFilterFlag) {
    // all = 'all',
    // external = 'external',
    ContactsFilterFlag["crossPlatform"] = "crossPlatform";
    ContactsFilterFlag["sameTeam"] = "sameTeam";
    ContactsFilterFlag["crossTeam"] = "crossTeam";
})(ContactsFilterFlag || (ContactsFilterFlag = {}));
export var BusinessType;
(function (BusinessType) {
    BusinessType["work"] = "WORK";
    BusinessType["project"] = "PROJECT";
    BusinessType["group"] = "GROUP";
})(BusinessType || (BusinessType = {}));
export var SearchType;
(function (SearchType) {
    SearchType["All"] = "0";
    SearchType["Contacts"] = "1";
    SearchType["Group"] = "2";
    SearchType["App"] = "3";
    SearchType["JoySpace"] = "4";
    SearchType["Task"] = "5";
    SearchType["Schedule"] = "6";
    SearchType["MessageHistory"] = "-1";
    SearchType["Department"] = "7";
    SearchType["Device"] = "8";
})(SearchType || (SearchType = {}));
export var SelectGroupType;
(function (SelectGroupType) {
    SelectGroupType[SelectGroupType["innerGroup"] = 1] = "innerGroup";
    SelectGroupType[SelectGroupType["crossTenement"] = 2] = "crossTenement";
    SelectGroupType[SelectGroupType["crossPlatform"] = 4] = "crossPlatform";
    SelectGroupType[SelectGroupType["innerAndCrossTenement"] = 3] = "innerAndCrossTenement";
    SelectGroupType[SelectGroupType["innerAndCrossPlatform"] = 5] = "innerAndCrossPlatform";
    SelectGroupType[SelectGroupType["all"] = 7] = "all"; // 所有类型的组
})(SelectGroupType || (SelectGroupType = {}));
export var ContactShowType;
(function (ContactShowType) {
    ContactShowType[ContactShowType["innerSameTeam"] = 1] = "innerSameTeam";
    ContactShowType[ContactShowType["innerSameTeamExternal"] = 2] = "innerSameTeamExternal";
    ContactShowType[ContactShowType["crossTeam"] = 4] = "crossTeam";
    ContactShowType[ContactShowType["crossPlatform"] = 8] = "crossPlatform";
    ContactShowType[ContactShowType["sameTenement"] = 3] = "sameTenement";
    ContactShowType[ContactShowType["multiTenement"] = 7] = "multiTenement";
    ContactShowType[ContactShowType["crossTeamAndCrossPlatform"] = 12] = "crossTeamAndCrossPlatform";
    ContactShowType[ContactShowType["ExternalAndCrossTeamAndCrossPlatform"] = 13] = "ExternalAndCrossTeamAndCrossPlatform";
    ContactShowType[ContactShowType["all"] = 15] = "all";
})(ContactShowType || (ContactShowType = {}));
export var UserTypeEnum;
(function (UserTypeEnum) {
    UserTypeEnum["external"] = "1";
    UserTypeEnum["unCertify"] = "2";
    UserTypeEnum["formal"] = "3";
    UserTypeEnum["crossTeam"] = "4";
    UserTypeEnum["crossPlatform"] = "5";
})(UserTypeEnum || (UserTypeEnum = {}));
//# sourceMappingURL=types.js.map